import { HOME_URL } from "../constants";

// https://stackoverflow.com/questions/29032437/are-urls-with-amp-instead-of-treated-the-same-by-search-engines
// &amp - it is ok for robots

export const generateAlternateLinksForSEO = (locales = [], location) => {
  const { pathname, search } = location;
  const pathSegments = pathname.split("/");

  const currentLang = locales.find(
    locale => locale.code === pathSegments[1],
  )?.code;

  const cleanedPath = currentLang
    ? pathname.replace(`/${currentLang}`, "")
    : pathname;

  const cleanedPathNormalized = cleanedPath.replace(/^\/+/, "");

  const getLangPrefix = lang => (lang === "en" ? "" : `${lang}`);

  const baseUrl = HOME_URL.replace(/\/+$/, "");

  const links = locales.map(({ code, id }) => {
    const langPrefix = getLangPrefix(code);
    const href = `${baseUrl}/${langPrefix ? langPrefix + "/" : ""}${cleanedPathNormalized}${search}`;

    return <link rel="alternate" hrefLang={code} href={href} key={id} />;
  });

  const defaultHref = `${baseUrl}/${cleanedPathNormalized}${search}`;

  links.push(
    <link
      rel="alternate"
      hrefLang="x-default"
      href={defaultHref}
      key="x-default"
    />,
  );

  return links;
};
